import React, { useState, useEffect } from "react";
import { Phone, Mail, MapPin, Send } from "lucide-react";
import {
  server_post_data,
  save_form_by_email,
} from "../ServiceConnection/serviceconnection";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleEmailChange,
  handleError,
  handleNumbersChange,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
let click_time = 0;
const Contact = () => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const handleSaveChangesdynamic = async (form_data, save_venueowner) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data && click_time === 0) {
      click_time = 1;
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      await server_post_data(save_venueowner, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          let data = Response.split("~@~");
          if (parseInt(data[0]) === 1) {
            handleError("Error", data[1]);
          } else {
            click_time = 0;
            handleSuccess(data[1]);
            empty_form(form_data);
          }
        })
        .catch((error) => {
          click_time = 0;
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-slide-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h2>
          <p className="text-xl text-gray-600">
            Get in touch with our team for all your transportation needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white rounded-lg shadow-lg p-8 transform hover:scale-[1.02] transition-transform duration-300">
            <form className="space-y-6" id="listmyhotel">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="user_name"
                  maxLength={70}
                  onChange={handleAphabetsChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#F80D01] focus:ring-[#F80D01] transition-all duration-300 form-control trio_mandatory"
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  onChange={handleEmailChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#F80D01] focus:ring-[#F80D01] transition-all duration-300 form-control trio_mandatory"
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Contact number
                </label>
                <input
                  type="text"
                  id="contactNumber"
                  name="contactNumber"
                  maxLength={10}
                  placeholder="+91-XXXXXXXXXX"
                  onChange={handleNumbersChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#F80D01] focus:ring-[#F80D01] transition-all duration-300 form-control trio_mandatory"
                />
              </div>
              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  maxLength={500}
                  rows={4}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#F80D01] focus:ring-[#F80D01] transition-all duration-300 form-control trio_mandatory"
                ></textarea>
              </div>
              <button
                type="button"
                onClick={() => {
                  handleSaveChangesdynamic("listmyhotel", save_form_by_email);
                }}
                className="group w-full bg-[#F80D01] text-white px-6 py-3 rounded-md hover:bg-red-700 transition-all duration-300 hover:shadow-lg flex items-center justify-center space-x-2"
              >
                <span>Send Message</span>
                <Send className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
              </button>
            </form>
          </div>

          <div className="space-y-8">
            {[
              {
                icon: <Phone />,
                title: "Phone",
                content: ["+91 9893053069", "+91 9827053069"],
              },
              {
                icon: <Mail />,
                title: "Email",
                content: ["operations@nsirl.com"],
              },
              {
                icon: <MapPin />,
                title: "Address",
                content: [
                  "269/1/2, Village-Rapadia, Near Deepak Warehouse,",
                  "11 mile Bye pass Road, Bhopal (M.P.)",
                  "India",
                ],
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="text-[#F80D01] flex-shrink-0 animate-float">
                  {item.icon}
                </div>
                <div>
                  <h3 className="text-lg font-medium text-gray-900">
                    {item.title}
                  </h3>
                  {item.content.map((line, i) => (
                    <p key={i} className="mt-1 text-gray-600">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
